import '../styles/application.css'
// JS сайта (каталог и контент-страницы). Игры — отдельные entrypoints
// в entrypoints/games/, они грузятся без Turbo и без Stimulus.
import '@hotwired/turbo-rails'
import { Application } from '@hotwired/stimulus'

const application = Application.start()

const controllers = import.meta.glob('../controllers/*_controller.js', { eager: true })
for (const [path, module] of Object.entries(controllers)) {
  const name = path.split('/').pop().replace('_controller.js', '').replaceAll('_', '-')
  application.register(name, module.default)
}
